import Axios from 'axios';
import { all, fork, takeEvery } from 'redux-saga/effects';
import {
	COUPON_CATEGORIES_CREATE,
	COUPON_CATEGORIES_UPDATE,
	COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS,
	COUPON_CATEGORIES_GET_DETAILS,
} from 'Constants/actionTypes';
import { apiUrl } from 'Constants/defaultValues';
import { defaultFetchDataFunc } from 'Util/Saga';
import {
	couponCategoriesCreateSuccess,
	couponCategoriesCreateFail,
	couponCategoriesUpdateSuccess,
	couponCategoriesUpdateFail,
	couponCategoriesFindAllByPageAndOptionsSuccess,
	couponCategoriesFindAllByPageAndOptionsFail,
	couponCategoriesGetDetailsSuccess,
	couponCategoriesGetDetailsFail,
} from './actions';

export function* watchCouponCategoriesCreate() {
	yield takeEvery(COUPON_CATEGORIES_CREATE, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.post(`${apiUrl}/couponCategory/create`, data);
			return response.data;
		},
		couponCategoriesCreateSuccess,
		couponCategoriesCreateFail
	));
}

export function* watchCouponCategoriesUpdate() {
	yield takeEvery(COUPON_CATEGORIES_UPDATE, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.put(`${apiUrl}/couponCategory/update`, data);
			return response.data;
		},
		couponCategoriesUpdateSuccess,
		couponCategoriesUpdateFail
	));
}

export function* watchCouponCategoriesFindAllByPageAndOptions() {
	yield takeEvery(COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.get(`${apiUrl}/couponCategory/findAllByPageAndOptions`, { params: data });
			return response.data;
		},
		couponCategoriesFindAllByPageAndOptionsSuccess,
		couponCategoriesFindAllByPageAndOptionsFail
	));
}

export function* watchCouponCategoriesGetDetails() {
	yield takeEvery(COUPON_CATEGORIES_GET_DETAILS, defaultFetchDataFunc(
		async (data) => {
			const response = await Axios.get(`${apiUrl}/couponCategory/details`, { params: { category: data } });
			return response.data;
		},
		couponCategoriesGetDetailsSuccess,
		couponCategoriesGetDetailsFail
	));
}

export default function* rootSaga() {
	yield all([
		fork(watchCouponCategoriesCreate),
		fork(watchCouponCategoriesUpdate),
		fork(watchCouponCategoriesFindAllByPageAndOptions),
		fork(watchCouponCategoriesGetDetails),
	]);
}
